import style from './style';

const Checkbox = props => (
  <label class={style.checkbox}>
    <input
      type={props.type ? props.type : 'checkbox'}
      checked={props.checked}
      disabled={props.disabled}
      onChange={props.onChange}
      id={props.id}
      name={props.name}
    />
    <span class={style.indicator}></span>
    <main class={style.content}>{props.children}</main>
  </label>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.js